
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-label-color, hsl(from var(--ig-primary-500-contrast) h s l/0.6));--disabled-color: var(--ig-label-disabled-color, hsl(from var(--ig-primary-500-contrast) h s l/0.2));--ig-theme: indigo;--ig-theme-variant: dark}`;
  